module.exports = __webpack_public_path__ + "img/formlabs.80ba4a77.png";